// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__25zIn","title":"FrontImage_title__FG4BW"};